import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchMIL1Action = (emailId) => {
    return async function (dispatch) {       
        dispatch({ type: 'LOADING_MI_L1_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/mi-page/l1-page?email=${encodeURIComponent(emailId)}`);
            var resData = Object.assign({ type: 'SUCCESS_MI_L1_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_MI_L1_ACTION', error });
        }

        
        dispatch(resData);
    };
};

const FetchIsFavoriteL1Action = (payload={}) => {
    // return async function (dispatch) {       
    //     dispatch({ type: 'LOADING_IS_FAVORITE_L1_ACTION' });
    //     try {
    //         const data = await postApiCall(`${appConstants.BASE_URL}/mi-page/favorite-category`);
    //         var resData = Object.assign({ type: 'SUCCESS_IS_FAVORITE_L1_ACTION' }, data);
    //         dispatch(resData);

    //     } catch (error) {
    //         dispatch({ type: 'ERROR_IS_FAVORITE_L1_ACTION', error });
    //     }

        
    //     dispatch(resData);
    // };

    return async function (dispatch) {
        dispatch({ type: 'LOADING_IS_FAVORITE_L1_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/mi-page/favorite-L1-category`, payload);
            var resData = Object.assign({ type: 'SUCCESS_IS_FAVORITE_L1_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_IS_FAVORITE_L1_ACTION', error });
        }
    };
};

const FetchIsFavoriteL1L2Action = (payload={}) => {

    return async function (dispatch) {
        dispatch({ type: 'LOADING_IS_FAVORITE_L1_L2_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/mi-page/favorite-L1-L2-category`, payload);
            var resData = Object.assign({ type: 'SUCCESS_IS_FAVORITE_L1_L2_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_IS_FAVORITE_L1_L2_ACTION', error });
        }
    };
};

const FetchMIL2Action = (category, emailId) => {
     return async function (dispatch) {       
        dispatch({ type: 'LOADING_MI_L2_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/mi-page/l2-page?category=${encodeURIComponent(category)}&email=${encodeURIComponent(emailId)}`);
            var resData = Object.assign({ type: 'SUCCESS_MI_L2_ACTION' }, data);
            dispatch(resData);

        } catch (error) {
            dispatch({ type: 'ERROR_MI_L2_ACTION', error });
        }

        
        dispatch(resData);
    };
};


export {
    FetchMIL1Action,
    FetchMIL2Action,
    FetchIsFavoriteL1Action,
    FetchIsFavoriteL1L2Action
}